var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftSparkles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 76,
    viewBox: "0 0 81 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2484 54.5651C23.2226 53.3759 20.6163 54.054 19.4271 56.0798C18.2378 58.1056 18.916 60.7119 20.9417 61.9011C22.9675 63.0904 25.5738 62.4122 26.7631 60.3864C27.9523 58.3607 27.2742 55.7544 25.2484 54.5651Z",
    fill: "#3897FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2179 31.9995L73.6366 39.3753L79.2162 44.2173L71.8404 44.636L66.9984 50.2156L66.5793 42.84L61.0001 37.9978L68.3758 37.5791L73.2179 31.9995Z",
    fill: "#FFCC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8897 14.9882L34.3034 20.9122L41.6274 21.8788L35.7029 26.2925L34.7367 33.6165L30.323 27.6924L22.9991 26.7258L28.9229 22.3123L29.8897 14.9882Z",
    fill: "#8E4DD5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftSparkles);
export default __webpack_public_path__ + "static/media/leftSparkles.db09b3a66e636167accb71e9b6c485d5.svg";
export { ForwardRef as ReactComponent };